import ExpoAiLogo from 'pared/images/Expo/expoai.png'

import { IConfigsType } from '../../types'

const burgerworksHome: IConfigsType = {
  burgerworks: {
    '/:brand/scorecard': {
      groupFilter: {
        api: 'locationFilter',
      },
      title: {
        type: 'title',
        title: 'locationInfo',
        subTitle: 'storeSubtitle',
      },
      image: {
        type: 'image',
        src: ExpoAiLogo,
        alt: 'Expo AI',
        height: '40px',
      },
      exray: {
        type: 'ai-summary',
        fields: ['labor', 'uLossPrevention', 'guest', 'uDelivery', 'uSales'],
      },
      chatbox: {
        type: 'chatbox',
        // hasSalesAnalysisButton: true, // unmark this line to publish the sales analysis button
      },
    },
  },
}

export default burgerworksHome
